module.exports = __webpack_public_path__ + "img/VorsichtSieBeißt.d17593a3.jpg";